import adminParametersReducer from './reducers'

export { default as adminParametersActions } from './actions'
export { default as adminParametersSagas } from './sagas'

export default adminParametersReducer